"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAriaAndDataProps = exports.omitProps = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var omitProps = function omitProps(Component, omitted) {
  return function (props) {
    var filteredProps = (0, _extends2.default)({}, props);
    omitted.forEach(function (propName) {
      delete filteredProps[propName];
    });
    return _react.default.createElement(Component, filteredProps);
  };
};
/**
 * @param {Object} props
 * @return {Object} The subset of the given props whose names start with `aria-` or `data-`
 */


exports.omitProps = omitProps;

var getAriaAndDataProps = function getAriaAndDataProps(props) {
  var propKeyRegex = /^((aria-)|(data-))/;
  return Object.keys(props).reduce(function (acc, key) {
    if (!key) return acc;

    if (key.match(propKeyRegex)) {
      acc[key] = props[key];
    }

    return acc;
  }, {});
};

exports.getAriaAndDataProps = getAriaAndDataProps;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/Props.js
// module id = 266
// module chunks = 209 210 211 212